const NetFlixRoutes = [
    {
        path: '/which-countries-have-the-cheapest-netflix',
        name: 'Netflix',
        component: () => import(/* webpackChunkName: "netflix" */'@/views/3-in-1/netflix/Netflix.vue')
    },
     {
        path: '/en/which-countries-have-the-cheapest-netflix',
        name: 'NetflixEN',
        component: () => import(/* webpackChunkName: "netflix" */'@/views/3-in-1/netflix/Netflix.vue')
    },
    {
        path: '/cn/which-countries-have-the-cheapest-netflix',
        name: 'NetflixCN',
        component: () => import(/* webpackChunkName: "netflix" */'@/views/3-in-1/netflix/Netflix.vue')
    },
    {
        path: '/br/which-countries-have-the-cheapest-netflix',
        name: 'NetflixBR',
        component: () => import(/* webpackChunkName: "netflix" */'@/views/3-in-1/netflix/Netflix.vue')
    },
    {
        path: '/de/which-countries-have-the-cheapest-netflix',
        name: 'NetflixDE',
        component: () => import(/* webpackChunkName: "netflix" */'@/views/3-in-1/netflix/Netflix.vue')
    },
    {
        path: '/es/which-countries-have-the-cheapest-netflix',
        name: 'NetflixES',
        component: () => import(/* webpackChunkName: "netflix" */'@/views/3-in-1/netflix/Netflix.vue')
    },
    {
        path: '/FR/which-countries-have-the-cheapest-netflix',
        name: 'NetflixFR',
        component: () => import(/* webpackChunkName: "netflix" */'@/views/3-in-1/netflix/Netflix.vue')
    },
    {
        path: '/it/which-countries-have-the-cheapest-netflix',
        name: 'NetflixIT',
        component: () => import(/* webpackChunkName: "netflix" */'@/views/3-in-1/netflix/Netflix.vue')
    },
    {
        path: '/jp/which-countries-have-the-cheapest-netflix',
        name: 'NetflixJP',
        component: () => import(/* webpackChunkName: "netflix" */'@/views/3-in-1/netflix/Netflix.vue')
    },
    {
        path: '/ko/which-countries-have-the-cheapest-netflix',
        name: 'NetflixKO',
        component: () => import(/* webpackChunkName: "netflix" */'@/views/3-in-1/netflix/Netflix.vue')
    },
    {
        path: '/ru/which-countries-have-the-cheapest-netflix',
        name: 'NetflixRU',
        component: () => import(/* webpackChunkName: "netflix" */'@/views/3-in-1/netflix/Netflix.vue')
    }
]

export default NetFlixRoutes;

